'use client';

import { Alert, Button } from '@/components';

type RecoverySuccessProps = {
  onBackToLogin: () => void;
};

export const RecoverySuccess = ({ onBackToLogin }: RecoverySuccessProps) => {
  return (
    <div className="flex flex-col gap-5 p-2 text-center">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Tudo certo</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Seu telefone foi atualizado e você já pode voltar ao login.
        </p>
      </div>

      <Alert
        variant="success"
        title="Telefone atualizado com sucesso"
        description="Use o novo telefone junto com o CPF para acessar a conta."
      />

      <Button
        type="button"
        variant="primary"
        size="large"
        className="h-12 w-full text-base"
        onClick={onBackToLogin}
      >
        Voltar ao login
      </Button>
    </div>
  );
};
